import type { NotificationHubTemplateBlockInput } from '@/__generated__/graphql/types';

import {
  METRICA_POR_ID,
  MetricaSinTokenDelContrato,
} from './components/team-metrics/metric-token-map';
import type { TTeamMetricId } from './components/team-metrics/types';
import type {
  TEmailEditorBlock,
  TMetricsBlock,
} from './mail-canvas/blocks/block-types';

export type TResolveMetricLabel = (metricId: TTeamMetricId) => string;

type TContractProps = NotificationHubTemplateBlockInput['props'];

const metricsItemsFor = (
  block: TMetricsBlock,
  resolveMetricLabel: TResolveMetricLabel,
): TContractProps => ({
  items: block.metricIds.map(metricId => {
    const entrada = METRICA_POR_ID.get(metricId);

    if (!entrada) {
      throw new MetricaSinTokenDelContrato(metricId);
    }

    return {
      token: entrada.token,
      label: resolveMetricLabel(metricId),
      display: entrada.display,
    };
  }),
});

export const blockPropsForContract = (
  block: TEmailEditorBlock,
  resolveMetricLabel: TResolveMetricLabel,
): TContractProps | undefined => {
  if (block.type === 'TEXT') {
    return { html: block.html, align: block.align ?? 'LEFT' };
  }

  if (block.type === 'BUTTON') {
    return {
      text: block.text,
      href: block.link,
      align: block.align ?? 'CENTER',
      variant: block.variant ?? 'PRIMARY',
    };
  }

  if (block.type === 'IMAGE') {
    return block.fileId
      ? {
          file_id: block.fileId,
          alt: block.alt ?? '',
          width: block.width ?? 600,
        }
      : undefined;
  }

  if (block.type === 'DIVIDER') {
    return {};
  }

  return metricsItemsFor(block, resolveMetricLabel);
};
